<template>
	<div class="page-header">
		<Grid :fullWidth="true">
			<Column :m="4">
				<div class="page-header__block">
					<img
						class="page-header__event-logo"
						v-if="shopConfig?.festivalData?.logo"
						:src="cdnUrl(shopConfig?.festivalData?.logo)"
					/>
				</div>
			</Column>

			<Column :m="6">
				<div class="page-header__block page-header__block--left">
					<h1 v-if="title" class="page-header__title">{{ title }}</h1>
					<div v-if="body" class="page-header__body" v-html="body"></div>
				</div>
			</Column>
		</Grid>
	</div>
</template>

<script>
export default {
	name: 'PageHeader',

	props: {
		title: String,
		body: String,
		image: Object
	},

	computed: {
		currentHeroImage() {
			if (!this.shopConfig) return {};

			const { festivalData } = this.shopConfig || {};
			const { heroImage } = festivalData || {};

			return festivalData ? heroImage : this.$store.getters.getMainBackgroundImage;
		},

		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		}
	}
};
</script>

<style lang="scss">
$component: 'page-header';

$component-padding: 20px;

.#{$component} {
	position: relative;

	padding: var(--global-spacing) 0;

	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-color: var(--content-background-opaque);

	&:after {
		content: '';
		position: absolute;
		display: block;

		left: 0;
		bottom: 0;

		width: 100%;
		height: 1px;

		background-color: rgba(255, 255, 255, 0.2);
	}

	&__block {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		height: 100%;

		&--left {
			align-items: flex-start;
		}
	}

	&__event-logo-wrapper {
		text-align: center;
	}

	&__event-logo {
		max-width: 120px;
		max-height: 120px;
	}

	&__event-date {
		display: block;
		font-size: 16px;
	}

	&__body {
		font-size: 14px;
	}

	@include md-lg {
		&__title {
			margin-bottom: calc($global-spacing / 2);
		}
	}

	@include sm {
		height: auto;
		padding: 40px 20px;

		margin-left: -$global-spacing--mobile;
		margin-right: -$global-spacing--mobile;

		&--has-counter {
			padding-top: 44px;
		}

		> * {
			position: relative;
			z-index: 1;
		}

		&:after {
			content: '';
			display: block;

			position: absolute;
			top: 0;
			left: -40px;

			width: calc(100% + 70px);
			height: 100%;
			background-color: rgba(var(--navbar-bg-color), 0.7);
		}

		&__block {
			height: auto;

			&--left {
				padding-bottom: 0;
				text-align: center;
				align-items: center;
				height: auto;

				> h1 {
					text-transform: uppercase;
				}
			}
		}

		&__body {
			font-size: 14px;
		}

		&__event-logo {
			margin: 20px 0;
		}
	}
}
</style>
